import { useIntl as useIntlSource } from 'gatsby-plugin-intl'


export const useIntl = () => {
  const intl = useIntlSource()

  return (id, values = {}) => intl.formatMessage({ id }, values)
}
